import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { startCase } from 'lodash';
import { processValidate } from 'infrastructure/form';
import renderRadioButtonField from './RadioButton';

import './RadioButtonField.scss';

/** Custom styled radio button */

const RadioButtonField = props => {
  const { validate, label, name, radioValue, onChange, value } = props;
  return (
    <Field
      {...props}
      type="radio"
      name={name}
      label={label}
      validate={processValidate(label || startCase(name), validate, props)}
      render={({ form, field, ...p }) =>
        renderRadioButtonField({
          input: {
            ...field,
            onChange: v =>
              onChange ? onChange(v) : form.setFieldValue(name, v),
            value: value || form.values[name] || '',
          },
          label,
          radioValue,
          ...p,
        })
      }
    />
  );
};
RadioButtonField.propTypes = {
  /** Field label */
  label: PropTypes.string,
  /** Input name & ID */
  name: PropTypes.string,
  /** Optional custom onChange function */
  onChange: PropTypes.func,
  /** Validation array */
  validate: PropTypes.arrayOf(PropTypes.shape({})),
  radioValue: PropTypes.string,
  value: PropTypes.string,
};
RadioButtonField.defaultProps = {
  label: '',
  name: '',
  onChange: null,
  validate: [],
  radioValue: '',
  value: null,
};

export default RadioButtonField;
